/* ════════════════════════════════════════════════════════════════════
   TRANSDERMA · French (fr) string table — Shop landing page
   English is the source of truth in the HTML; this file supplies the
   French counterpart for each shop.* key. Missing keys fall back to
   English (see i18n.js). Claim-bearing copy: faithful renderings only,
   no strengthening or embellishment. The only standing discount is the
   routine-builder 10% (auto-applied at checkout for 2+ serums).

   House voice: calm, exact, short. No em dashes in prose (use periods,
   commas, or the mid-dot · ). EXCEPTION: combo card labels keep the
   existing em dash ("Serum C — Brightening"), mirrored faithfully.
   Informal "tu". Product names, prices and proper nouns stay as-is.
═════════════════════════════════════════════════════════════════════ */
(function(){
  window.TD_I18N = window.TD_I18N || {};
  window.TD_I18N.fr = window.TD_I18N.fr || {};
  Object.assign(window.TD_I18N.fr, {

    /* ── Nav (page-specific) ── */
    'shop.nav.build': 'Construis une routine',

    /* ── Serum grid ── */
    'shop.grid.title': 'Soin de la peau sans compromis',
    'shop.addcart': 'Ajouter au panier',
    'shop.time.day': 'Jour',
    'shop.time.night': 'Nuit',
    'shop.time.both': 'Jour et nuit',
    'shop.card.c.benefit': 'Protège, illumine et raffermit avec de la vitamine C pure.',
    'shop.card.a.benefit': 'Renouvellement piloté par le rétinol pendant que tu dors.',
    'shop.card.o.benefit': 'Donne de l\'énergie aux cellules et restaure la luminosité visible.',
    'shop.card.m.benefit': 'Répare la barrière d\'hydratation. En profondeur et durablement.',
    'shop.card.r.benefit': 'Raffermit et restaure. Réduit les imperfections et la texture inégale au fil du temps.',

    /* ── Benefit strip ── */
    'shop.strip.1.t': 'Sans conservateurs',
    'shop.strip.1.b': 'Emballage airless et résistant aux UV qui protège chaque actif. Pas de stabilisateurs, pas de compromis.',
    'shop.strip.2.t': 'Libération transdermique',
    'shop.strip.2.b': 'Un système porteur sans eau transporte les vitamines actives au-delà de la surface jusqu\'au derme, là où se produisent la synthèse du collagène et le renouvellement cellulaire.',
    'shop.strip.3.t': '2 ans de conservation',
    'shop.strip.3.b': 'Pas d\'eau signifie pas de croissance bactérienne. Stable et puissant de la première à la dernière utilisation.',
    'shop.strip.4.t': 'Sans cruauté',
    'shop.strip.4.b': 'Jamais testé sur les animaux. Développé cliniquement, livré de façon responsable.',

    /* ── Combo builder ── */
    'shop.combo.label': 'Construis ta routine',
    'shop.combo.h2': 'Deux sérums ou plus ?<br><em>Dix pour cent de remise.</em>',
    'shop.combo.c.name': 'Serum C — Luminosité',
    'shop.combo.c.desc': 'Vitamine C · Jour · Taches sombres et luminosité',
    'shop.combo.a.name': 'Serum A — Renouvellement',
    'shop.combo.a.desc': 'Vitamine A · Nuit · Renouvellement cellulaire et texture',
    'shop.combo.o.name': 'Serum O — Oxygénant',
    'shop.combo.o.desc': 'Vitamine O · Jour · Vitalité cellulaire et teint',
    'shop.combo.m.name': 'Serum M — Hydratation',
    'shop.combo.m.desc': 'Vitamine M · Jour + nuit · Hydratation et barrière',
    'shop.combo.r.name': 'Serum R — Antioxydant',
    'shop.combo.r.desc': 'Resvératrol · Jour + nuit · Protection et longévité',

    /* ── Combo summary sidebar ── */
    'shop.concern.label': 'Achète selon le besoin de la peau',
    'shop.concern.placeholder': 'Choisis un besoin…',
    'shop.concern.firmness': 'Fermeté',
    'shop.concern.brightness': 'Luminosité',
    'shop.concern.hydration': 'Hydratation',
    'shop.concern.finelines': 'Ridules',
    'shop.concern.darkspots': 'Taches sombres',
    'shop.concern.texture': 'Texture',
    'shop.concern.acnescars': 'Cicatrices d\'acné',
    'shop.concern.dullness': 'Teint terne',
    'shop.sum.title': 'Ta routine',
    'shop.sum.empty': 'Choisis des sérums pour commencer',
    'shop.sum.discount': 'Remise routine (10%)',
    'shop.sum.total': 'Total',
    'shop.sum.addbtn': 'Ajouter la routine au panier',
    'shop.sum.note': 'Livraison gratuite dans le monde entier · 2 ans de conservation garantis',

    /* ── Sample / Discovery Kit ── */
    'shop.samp.eyebrow': 'Tu ne sais pas par où commencer ?',
    'shop.samp.title': 'Essaie les cinq<br><em>pour $70.</em>',
    'shop.samp.body': 'Le Transderma Discovery Kit contient des formats de poche des cinq sérums. C\'est ainsi que la plupart de nos clients de longue date nous ont découverts.',
    'shop.samp.cta': 'Procurez-toi le Discovery Kit',
    'shop.samp.fine': '$5 de livraison dans le monde entier · Expédié depuis Stockholm',
    'shop.samp.f1.t': 'Les cinq sérums',
    'shop.samp.f1.b': 'Formats de poche de C, A, O, M et R, 3 ml chacun. Environ 7 jours d\'utilisation régulière par flacon.',
    'shop.samp.f2.t': 'Les cinq, côte à côte',
    'shop.samp.f2.b': 'Fais passer chaque formule dans ta routine la même semaine et trouve les combinaisons qui fonctionnent pour ta peau.',
    'shop.samp.f3.t': 'Sans engagement',
    'shop.samp.f3.b': 'Tu sauras en une semaine si Transderma est fait pour toi. La plupart le savent en quelques jours.',

    /* ── Gift voucher ── */
    'shop.gift.title': 'Offre <em>Transderma</em> en cadeau',
    'shop.gift.sub': 'Un bon numérique livré par e-mail. Utilisable sur chaque sérum et sur le Discovery Kit.',
    'shop.gift.btn': 'Acheter maintenant',

    /* ── Discovery Kit product page (shopify-theme/templates/product.transderma-discovery-kit.liquid) ── */
    'shop.kit.crumb.home': 'Accueil',
    'shop.kit.crumb.current': 'Discovery Kit',

    /* Hero */
    'shop.kit.eyebrow': 'Cinq sérums vitaminés · Un kit',
    'shop.kit.tagline': 'Formats de poche des cinq sérums Transderma. Environ 7 jours d\'utilisation quotidienne pour l\'ensemble du kit. Essaie le système complet avant de te décider pour des flacons grand format.',
    'shop.kit.price.meta': 'Cinq mini-flacons · 3 ml chacun',
    'shop.kit.addcart': 'Ajouter au panier · $70',
    'shop.kit.soldout': 'Épuisé · bientôt de retour',
    'shop.kit.reserve': 'Réserve ton kit',

    /* Hero meta */
    'shop.kit.meta.inside': 'Ce que ça comprend',
    'shop.kit.meta.inside.v': '5 mini-flacons · 3 ml chacun',
    'shop.kit.meta.lasts': 'Durée',
    'shop.kit.meta.lasts.v': '~7 jours d\'utilisation quotidienne',
    'shop.kit.meta.formula': 'Formule',
    'shop.kit.meta.formula.v': '100% actif, sans eau',
    'shop.kit.meta.shelf': 'Conservation',
    'shop.kit.meta.shelf.v': '2 ans, puissant tout du long',

    /* What's inside */
    'shop.kit.inside.label': 'Ce que ça comprend',
    'shop.kit.inside.title': 'Cinq mini-flacons.<br><em>Une routine complète.</em>',
    'shop.kit.inside.intro': 'Chaque mini-flacon contient assez de sérum pour environ 7 jours d\'application quotidienne. Utilise-les séparément, superpose-les matin et soir, ou teste des combinaisons selon tes besoins.',
    'shop.kit.card.time.day': 'Jour',
    'shop.kit.card.time.night': 'Nuit',
    'shop.kit.card.time.both': 'Jour + nuit',
    'shop.kit.card.c.desc': 'Vitamine C pure. Illumine, protège, uniformise le teint.',
    'shop.kit.card.a.desc': 'Rétinol. Renouvellement cellulaire et texture, pendant que tu dors.',
    'shop.kit.card.o.desc': 'PQQ. Énergie cellulaire, vitalité, clarté.',
    'shop.kit.card.m.desc': 'Acide hyaluronique. Hydratation, plénitude, soutien de la barrière.',
    'shop.kit.card.r.desc': 'Resvératrol. Défense antioxydante et longévité.',

    /* Why try the kit */
    'shop.kit.why.label': 'Pourquoi commencer ici',
    'shop.kit.why.title': 'Trouve ta routine <em>avant</em> de t\'engager.',
    'shop.kit.why.intro': 'Un flacon grand format coûte $175 et dure plusieurs semaines d\'utilisation quotidienne. Le Discovery Kit est la façon la plus simple de savoir quels sérums fonctionnent sur ta peau, et quelles combinaisons font vraiment la différence pour tes besoins spécifiques.',
    'shop.kit.why.1.t': '~7 jours d\'utilisation réelle.',
    'shop.kit.why.1.b': 'Assez de sérum pour appliquer matin et soir pendant environ une semaine et commencer à voir des changements de texture, de teint et d\'hydratation. Ce n\'est pas un échantillon, c\'est une routine en marche.',
    'shop.kit.why.2.t': 'Les cinq, côte à côte.',
    'shop.kit.why.2.b': 'Fais passer chaque formule dans ta routine du matin et du soir la même semaine. Le kit est le moyen le plus rapide d\'apprendre quelles combinaisons font vraiment la différence pour ta peau.',
    'shop.kit.why.3.t': 'Les cinq pour moins d\'un demi-flacon.',
    'shop.kit.why.3.b': 'Un seul sérum Transderma grand format coûte $175. Le kit te donne les cinq pour $70 : la façon la plus économique de savoir à quelles formules ta peau répond réellement avant de te décider.',

    /* How it works */
    'shop.kit.how.label': 'Comment ça fonctionne',
    'shop.kit.how.title': 'Sept jours. <em>Une découverte.</em>',
    'shop.kit.how.intro': 'La plupart des clients le savent en cinq jours. Voici le chemin que la plupart suivent.',
    'shop.kit.how.s1.t': 'Jour 1 · Ouvre',
    'shop.kit.how.s1.b': 'Ouvre le kit. Choisis le besoin qui correspond au tien : luminosité, renouvellement ou hydratation.',
    'shop.kit.how.s2.t': 'Jours 1 à 3 · Teste',
    'shop.kit.how.s2.b': 'Applique ta routine matin et soir. Deux gouttes, pressées sur peau propre. Laisse chaque couche absorber 30 secondes.',
    'shop.kit.how.s3.t': 'Jours 4 à 7 · Affine',
    'shop.kit.how.s3.b': 'Au septième jour, tu sauras à quels sérums ta peau répond. Change de routine, superpose autrement, ou simplifie à deux.',
    'shop.kit.how.s4.t': 'Jour 8 · Passe à l\'échelle',
    'shop.kit.how.s4.b': 'Commande des flacons grand format des sérums qui ont fonctionné, dans la routine que tu as construite. Deux flacons ou plus = 10% de remise.',

    /* Delivery / returns */
    'shop.kit.del.shipping.t': 'Livraison',
    'shop.kit.del.shipping.b': 'Tarif unique de $5 de livraison dans le monde entier. Expédié depuis Stockholm, généralement 3 à 7 jours ouvrables. <a href="/pages/shipping-returns">Détails complets de livraison</a>.',
    'shop.kit.del.returns.t': 'Retours',
    'shop.kit.del.returns.b': 'Une fois ouvert, le Discovery Kit n\'est pas remboursable. Les kits non ouverts peuvent être retournés dans un délai de 14 jours. <a href="/pages/shipping-returns">Politique de retours</a>.',
    'shop.kit.del.approved.t': 'Approuvé et enregistré',
    'shop.kit.del.approved.b': 'Approuvé en laboratoire par Läkemedelsverket. Enregistré conformément à la législation européenne sur les cosmétiques. Jamais testé sur les animaux.'

  });
})();
